module.exports = __webpack_public_path__ + "img/PX.98aafc12.png";